export const LEGACY_ROLE_MAP: Record<string, string> = {
  'aplos_nca:global:admin': 'platform_admin',
  'aplos_nca:global:developer': 'platform_developer',
  'aplos_nca:tenant:admin': 'tenant_admin',
}

export function normalizeRole(role: string): string {
  const trimmed = role.trim()
  return Object.prototype.hasOwnProperty.call(LEGACY_ROLE_MAP, trimmed) ? LEGACY_ROLE_MAP[trimmed] : trimmed
}

export function normalizeRoles(roles: string[]): string[] {
  const normalized = roles.map(normalizeRole)
  return [...new Set(normalized)]
}
